import { useQuery } from '@tanstack/react-query';
import { Layout } from '../components/layout/Layout';
import { Header } from '../components/layout/Header';
import { Card } from '../components/ui/Card';
import { api } from '../services/api';
import { AnalyticsSummary } from '../types';

interface DashboardResponse {
  summary: AnalyticsSummary;
  metrics: { note: string };
}

function StatCard({ label, value }: { label: string; value: number }) {
  return (
    <Card>
      <p className="text-sm text-gray-500 font-body">{label}</p>
      <p className="text-3xl font-display font-bold text-falcon-navy mt-1">{value}</p>
    </Card>
  );
}

export function AnalyticsPage() {
  const { data, isLoading } = useQuery<DashboardResponse>({
    queryKey: ['analytics', 'dashboard'],
    queryFn: () => api.get('/analytics/dashboard').then((r) => r.data),
  });

  return (
    <Layout>
      <Header
        title="Analytics"
        subtitle="Content performance and pipeline metrics"
      />

      {isLoading ? (
        <div className="text-center py-16 text-gray-400 font-body text-sm">Loading...</div>
      ) : (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
            <StatCard label="Total Weeks" value={data?.summary.total ?? 0} />
            <StatCard label="Published" value={data?.summary.published ?? 0} />
            <StatCard label="In Progress" value={data?.summary.inProgress ?? 0} />
            <StatCard label="Pending Approval" value={data?.summary.pendingApproval ?? 0} />
          </div>

          <Card>
            <p className="font-display font-semibold text-falcon-navy mb-2">
              Full Analytics — Phase 2
            </p>
            <p className="text-sm text-gray-500 font-body">
              {data?.metrics.note}
            </p>
            <ul className="mt-4 space-y-2 text-sm text-gray-600 font-body list-disc list-inside">
              <li>Google Search Console rankings by keyword</li>
              <li>LinkedIn post engagement (impressions, clicks, reactions)</li>
              <li>Twitter/X thread performance</li>
              <li>CompSignal sign-up attribution by content piece</li>
              <li>Cost per piece (Claude API tokens) vs. pipeline influence</li>
            </ul>
          </Card>
        </>
      )}
    </Layout>
  );
}
